import api from "../apiConfig";

export const TestLoginAPI = async (email) => {
  try {
    const resp = await api.post("/api/auth/test/login2", {
      email: email,
      password: "CEAZER1234!!@",
    });
    return resp;
  } catch (error) {
    console.log("테스트 로그인 Error", error);
    return error;
  }
};
